// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"d40f541c","87":"98a7b17f","366":"b59d4f0c","567":"838c18c1","603":"70213cfc","925":"8a8ba5c0"}[chunkId] + ".chunk.css";
};